import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

//utils
import queries from '../../utils/queries'

import HomeSimu1 from './homesimu1';
import HomeSimu2 from './homesimu2';

import ConfSimAlar1 from './simu/confsimalar1';
import ConfSimAlar2 from './simu/confsimalar2';

import ConfSimRot1 from './simu/confsimrot1';
import ConfSimRot2 from './simu/confsimrot2';

import ConfSimVisco1 from './simu/confsimvisco1';
import ConfSimVisco2 from './simu/confsimvisco2';

import ConfSimFlujo1 from './simu/confsimflujo1';
import ConfSimFlujo2 from './simu/confsimflujo2';

function getNumDiasMes(mesDias, agnoDias){
  /*
      Los meses 1,3,5,7,8,10,12 siempre tienen 31 días
      Los meses 4,6,9,11 siempre tienen 30 días
      El mes de febrero dependiendo del año puede tener 28 o 29 días
  */
  let mes = parseInt(mesDias, 10)
  let agno = parseInt(agnoDias, 10)

  if( (mes === 1) || (mes === 3) || (mes === 5) || (mes === 7) || (mes === 8) || (mes === 10) || (mes === 12) ) 
    return 31;
  else if( (mes === 4) || (mes === 6) || (mes === 9) || (mes === 11) ) 
    return 30;
  else if( mes === 2 )
  {
      if((agno % 4 === 0) && ((agno % 100 !== 0) || (agno % 400 === 0)))
        return 29;
      else
        return 28;
  }   
}

class HomeSimu extends React.Component{
  state={
    showSimula: true, 
    showSimRot: false,
    showSimAlar: false, showSimVisco: false, showSimFlujo: false,
    permiteUpdate: false, permiteDelete: false,
    permiteClose: false, argsAdd: {}, errorAdd: [],
    idLista: {}, argsBuscar: {}, argsBuscGrado: {},
  }


  estadosFalse = () => {
    this.setState({argsAdd: {}})
    this.setState({errorAdd: []})

    Object.values(this.state).forEach((estado, i) => {
      if(estado===true){
        this.setState({ [Object.getOwnPropertyNames(this.state)[i]]: false })
      }
    })
  }

  ordenarArrayAsc = (array, campo) => {
    array.sort(function (a, b) {
       return a[campo] > b[campo];
    });
  }

  showSimula = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showSimula: true})
  }

  showSimAlar = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showSimAlar: true})
  }

  showSimVisco = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showSimVisco: true})
  }

  showSimRot = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showSimRot: true})
  }

  showSimFlujo = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showSimFlujo: true})
  }
  handleChange = (ev)=>{
    const argsAdd = this.state.argsAdd
    if(ev.target.type==='checkbox'){
      argsAdd[ev.target.name] = ev.target.checked
    }else{
      argsAdd[ev.target.name] = ev.target.value
    }
    this.setState({argsAdd});
  }

  handleClickUpd = (ev) => {
    ev.preventDefault()
    this.setState({permiteUpdate: true, permiteDelete: false, permiteClose: false})
  }

  handleClickDel = async (ev) => {
    ev.preventDefault()
    this.setState({permiteUpdate: false, permiteDelete: true, permiteClose: false})
  }

  handleClickClo = async (ev) => {
    ev.preventDefault()
    this.setState({permiteUpdate: false, permiteDelete: false, permiteClose: true})
  }

//   async componentDidUpdate(prevProps, prevState){
//     if(this.props.allGradoRtes.allGradoRtes){
//       // let argsQuery1 = `[{$group: {_id: {tipoGrado:"$tipoGrado", descrGrado:"$descrGrado", color:"$color", colorTexto:"$colorTexto"}}}, 
//       //   {$project: {tipoGrado:"$_id.tipoGrado", descrGrado:"$_id.descrGrado", color:"$_id.color", colorTexto:"$_id.colorTexto"}}, {$sort: {descrGrado: 1}}]`
//         let argsQuery1 = `[{$project: {descrGrado: 1}}, {$sort: {descrGrado: 1}}]`
            
//         let argsQuery = {tipoqry: `${argsQuery1}`}
//     let tipoG = []
//     let {data} = await this.props.allGradoRtes.refetch(argsQuery)
//     tipoG = await data.allGradoRtes
// console.log(tipoG)
//     }
//   }
  // async componentDidUpdate(prevProps){
  //   if(this.props.allGradoRtes.allGradoRtes&&!prevProps.allGradoRtes.allGradoRtes){

  //       let listRtes = []

  //       let argsBuscar=""
  
  //       argsBuscar = '{' + argsBuscar + '}'
  //       argsBuscar = {tipoqry: `[{$group: {_id: {tipoGrado:"$tipoGrado", descrGrado:"$descrGrado", color:"$color", colorTexto:"$colorTexto"}}}, 
  //          {$project: {_id: 0, tipoGrado:"$_id.tipoGrado", descrGrado:"$_id.descrGrado", color:"$_id.color", colorTexto:"$_id.colorTexto"}}, {$sort: {descrGrado: 1}}]`}
  
        
  //       let {data} = await this.props.allGradoRtes.refetch(argsBuscar)
  //       listRtes = await data.allGradoRtes
  //       // this.setState({listRtes})  
  //       console.log(listRtes)
  //   }
  // }    
  render(){
    const {showSimula, showSimRot, showSimAlar, showSimVisco, showSimFlujo,
          permiteUpdate, permiteDelete, permiteClose,
          argsAdd, errorAdd, argsBuscEstruct, idLista, argsBusc, argsBuscGrado, argsBuscar} = this.state;

      let lista = []
      let lista1 = []
      let lista2 = []
      let lista3 = []

      if (this.state.showSimRot) {
        if(this.props.allAplicacion.allAplicacion){lista = this.props.allAplicacion.allAplicacion}
        if(this.props.allGradoRtes.allGradoRtes){lista1 = this.props.allGradoRtes.allGradoRtes}
        if(this.props.allFrecuencia.allFrecuencia){lista2 = this.props.allFrecuencia.allFrecuencia}
        if(this.props.allGradoRtes1.allGradoRtes){lista3 = this.props.allGradoRtes1.allGradoRtes}
      }

      if (this.state.showSimAlar) {
        if(this.props.allAplicacion.allAplicacion){lista = this.props.allAplicacion.allAplicacion}
        if(this.props.allPrueba.allPrueba){lista2 = this.props.allPrueba.allPrueba}
      }
      if (this.state.showSimVisco) {
        if(this.props.allAplicacion.allAplicacion){lista = this.props.allAplicacion.allAplicacion}
        if(this.props.allPrueba.allPrueba){lista2 = this.props.allPrueba.allPrueba}
      }

    return (
      <div>
        <div className="ui two column stackable grid">
          <div className="column" style={this.props.styles.boxIzq}>
            {showSimula && <HomeSimu1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                        handleClickSel1={this.showSimRot} handleClickSel2={this.showSimAlar}
                        handleClickSel3={this.showSimVisco} handleClickSel4={this.showSimFlujo}/>}
          
            {showSimRot && <ConfSimRot1 styles={this.props.styles} handleClickRegr={this.showSimula}/>}  
            {showSimAlar && <ConfSimAlar1 styles={this.props.styles} handleClickRegr={this.showSimula}/>}         
            {showSimVisco && <ConfSimVisco1 styles={this.props.styles} handleClickRegr={this.showSimula}/>}  
            {showSimFlujo && <ConfSimFlujo1 styles={this.props.styles} handleClickRegr={this.showSimula}/>}  
      
          </div>

          <div className="column" style={this.props.styles.boxDer}>
            {showSimula && <HomeSimu2 styles={this.props.styles}/>}

            {showSimRot && <ConfSimRot2 styles={this.props.styles} list={lista} list1={lista1} list2={lista2} list3={lista3}/>}
            {showSimAlar && <ConfSimAlar2 styles={this.props.styles} list={lista} list2={lista2}/>}
            {showSimVisco && <ConfSimVisco2 styles={this.props.styles} list={lista} list2={lista2} handleChange={this.handleChange}/>}
            {showSimFlujo && <ConfSimFlujo2 styles={this.props.styles} list={lista} list2={lista2} handleChange={this.handleChange}/>}

          </div>
        </div>
      </div>
    )
  }
}

export default compose( 
  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),

  graphql(queries.query.allPrueba, {name:'allPrueba'}),

  graphql(queries.query.allAplicacion, {name:'allAplicacion'}),

  graphql(queries.query.allGrado, {name:'allGrado'}),
  graphql(queries.query.allFrecuencia, {name:'allFrecuencia'}),

  graphql(queries.query.allGradoRtes, {name:'allGradoRtes',
  options: (props) => {return {variables: {tipoqry: `[{$match: {'tipoGrado': {$ne: 'ISO'}}}, {$group: {_id: {tipoGrado:"$tipoGrado", descrGrado:"$descrGrado", color:"$color", colorTexto:"$colorTexto", aplicacionSAE:"$aplicacionSAE"}}}, 
  {$project: {_id: {$concat: ["$_id.tipoGrado", "$_id.descrGrado", "$_id.color", "$_id.colorTexto", "$_id.aplicacionSAE"]}, tipoGrado:"$_id.tipoGrado", descrGrado:"$_id.descrGrado", color:"$_id.color", colorTexto:"$_id.colorTexto", aplicacionSAE:"$_id.aplicacionSAE"}}, {$sort: {descrGrado: 1}}]`}}}}), 

  graphql(queries.query.allGradoRtes, {name:'allGradoRtes1',
  options: (props) => {return {variables: {tipoqry: `[{$match: {'tipoGrado': {$nin: ['SAE', 'NLGI']}}}, {$group: {_id: {tipoGrado:"$tipoGrado", descrGrado:"$descrGrado", color:"$color", colorTexto:"$colorTexto", aplicacionSAE:"$aplicacionSAE"}}}, 
  {$project: {_id: {$concat: ["$_id.tipoGrado", "$_id.descrGrado", "$_id.color", "$_id.colorTexto", "$_id.aplicacionSAE"]}, tipoGrado:"$_id.tipoGrado", descrGrado: {$toInt:"$_id.descrGrado"}, color:"$_id.color", colorTexto:"$_id.colorTexto", aplicacionSAE:"$_id.aplicacionSAE"}}, {$sort: {descrGrado: 1}}]`}}}}), 

    graphql(queries.mutation.fecha, {name:'fecha'}),
)(HomeSimu)
